import {useAuthTokens} from "@/features/identity/hooks/useAuthTokens.ts";
import {useAuthUser} from "./useAuthUser";
import {useHotelStorage} from "@/features/hotels/hooks/useHotelStorage.ts";
import {useAuthForm} from "@/features/identity/hooks/useAuthForm.ts";

export const useSignOut = () => {
    const {clearTokens} = useAuthTokens();
    const {setUser, setAuthenticated, setTenant} = useAuthUser();
    const {setSelectedHotel} = useHotelStorage();
    const {setFormStep} = useAuthForm();

    return () => {
        clearTokens();
        setUser(undefined);
        setAuthenticated(false);
        setTenant(undefined);
        setSelectedHotel({
            id: '',
            name: '',
        });
        setFormStep("login");
    }
}